import { createSlice } from "@reduxjs/toolkit";
import {
  getOrders,
  addOrder,
  updateOrders,
  deleteOrders,
  getSellers,
  addSellers,
  updateSellers,
  deleteSellers,
  getProductList,
  addProductList,
  updateProductList,
  deleteProductList,
  getProductGrid,
  addProductGrid,
  updateProductGrid,
  deleteProductGrid,
  getReview,
  addReview,
  updateReview,
  deleteReview,
  getDiamonds,
  addDiamonds,
  deleteDiamond,
  getAllInventories,
  updateInventory,
  deleteInventory,
  getDiamond,
  getDiamondByStockId,
  updateOrder,
  deleteOrder,
} from "./thunk";

export const initialState = {
  orders: [],
  orderStatusCounts: {},
  countsByStatus: {},
  countsPercentagesByMonth: {},
  sellers: [],
  diamonds: [],
  diamondPrices: [],
  cetnerDiamondPrices: [],
  shapes: [],
  diamond: {},
  productList: [],
  productGrid: [],
  reviews: [],
  inventories: [],
  errors: {},
  totalDiamonds: 0,
  currentPage: 1,
  isLoading: false,
};

const DiamondSlice = createSlice({
  name: "Diamond",
  initialState,
  reducers: {
    setCurrentPage: (state: any, action: any) => {
      state.currentPage = action.payload;
    },
    setIsLoading: (state: any, action: { payload: boolean }) => {
      state.isLoading = action.payload;
    },
    // Diamond Shapes
    addShapeSuccess: (state: any, action: any) => {
      state.shapes.unshift(action.payload);
    },
    addShapeError: (state: any, action: any) => {
      state.errors = action?.payload || null;
    },
    getShapesSuccess: (state: any, action: any) => {
      state.shapes = action.payload;
    },
    getShapesError: (state: any, action: any) => {
      state.errors = action.payload;
    },
    updateShapeSuccess: (state: any, action: any) => {
      state.shapes = state.shapes.map((shape: any) =>
        shape._id === action.payload._id
          ? { ...shape, ...action.payload }
          : shape
      );
    },
    updateShapeError: (state: any, action: any) => {
      state.errors = action?.payload || null;
    },
    deleteShapeSuccess: (state: any, action: any) => {
      state.shapes = state.shapes.filter(
        (shape: any) => shape._id !== action.payload
      );
    },
    deleteShapeError: (state: any, action: any) => {
      state.errors = action?.payload || null;
    },
    setDiamondPrices: (state: any, action: any) => {
      state.diamondPrices = action.payload;
    },
    getCenterDiamondPricesSuccess: (state: any, action: any) => {
      state.cetnerDiamondPrices = action.payload;
    },
    getCenterDiamondPricesError: (state: any, action: any) => {
      state.errors = action?.payload || null;
    },
    // countDiamondPrice: (state: any, action: any) => {
    //   state.countDiamondPrices = action.payload;
    // },
    handleError: (state: any, action: any) => {
      state.errors = action?.payload || null;
    },
  },
  extraReducers: (builder) => {
    // Inventories
    builder.addCase(getAllInventories.fulfilled, (state: any, action: any) => {
      state.inventories = action.payload;
    });
    builder.addCase(getAllInventories.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    builder.addCase(updateInventory.fulfilled, (state: any, action: any) => {
      state.inventories = state.inventories.map((inventory: any) =>
        inventory._id === action.payload._id
          ? { ...inventory, ...action.payload }
          : inventory
      );
    });
    builder.addCase(deleteInventory.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    builder.addCase(deleteInventory.fulfilled, (state: any, action: any) => {
      state.inventories = state.inventories.filter(
        (inventory: any) => String(inventory._id) !== String(action.payload)
      );
    });
    builder.addCase(updateInventory.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });

    // Orders
    builder.addCase(getOrders.fulfilled, (state: any, action: any) => {
      state.orders = action.payload.orders;
      state.countsByStatus = action.payload.countsByStatus;
      state.countsPercentagesByMonth = action.payload.countsPercentagesByMonth;
    });
    builder.addCase(getOrders.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    builder.addCase(addOrder.fulfilled, (state: any, action: any) => {
      state.orders.unshift(action.payload);
    });
    builder.addCase(addOrder.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    builder.addCase(updateOrder.fulfilled, (state: any, action: any) => {
      state.orders = state.orders.map((orders: any) =>
        orders._id === action.payload._id
          ? { ...orders, ...action.payload }
          : orders
      );
    });
    builder.addCase(updateOrder.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    builder.addCase(deleteOrder.fulfilled, (state: any, action: any) => {
      state.orders = state.orders.filter(
        (order: any) => order._id.toString() !== action.payload.toString()
      );
    });
    builder.addCase(deleteOrder.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });

    builder.addCase(deleteOrders.fulfilled, (state: any, action: any) => {
      state.orders = state.orders.filter(
        (orders: any) => orders.id.toString() !== action.payload.toString()
      );
    });
    builder.addCase(deleteOrders.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });

    // Sellers
    builder.addCase(getSellers.fulfilled, (state: any, action: any) => {
      state.sellers = action.payload;
    });
    builder.addCase(getSellers.rejected, (state: any, action: any) => {
      state.error = action.payload?.error || null;
    });
    builder.addCase(addSellers.fulfilled, (state: any, action: any) => {
      state.sellers.unshift(action.payload);
    });
    builder.addCase(addSellers.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    builder.addCase(updateSellers.fulfilled, (state: any, action: any) => {
      state.sellers = state.sellers.map((sellers: any) =>
        sellers.id === action.payload.id
          ? { ...sellers, ...action.payload }
          : sellers
      );
    });
    builder.addCase(updateSellers.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    builder.addCase(deleteSellers.fulfilled, (state: any, action: any) => {
      state.sellers = state.sellers.filter(
        (sellers: any) => sellers.id.toString() !== action.payload.toString()
      );
    });
    builder.addCase(deleteSellers.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });

    // Diamonds
    builder.addCase(getDiamonds.fulfilled, (state: any, action: any) => {
      state.diamonds = action.payload.data;
    });
    builder.addCase(getDiamonds.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    builder.addCase(addDiamonds.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    builder.addCase(addDiamonds.fulfilled, (state: any, action: any) => {
      state.diamonds = action.payload.data;
    });
    builder.addCase(deleteDiamond.fulfilled, (state: any, action: any) => {
      state.diamonds = state.diamonds.filter(
        (diamond: any) => diamond._id.toString() !== action.payload.toString()
      );
    });
    builder.addCase(deleteDiamond.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    builder.addCase(getDiamond.fulfilled, (state: any, action: any) => {
      state.diamond = action.payload;
    });
    builder.addCase(getDiamond.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    builder.addCase(
      getDiamondByStockId.fulfilled,
      (state: any, action: any) => {
        state.diamonds = action.payload;
      }
    );
    builder.addCase(getDiamondByStockId.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    // Products

    // List View
    builder.addCase(getProductList.fulfilled, (state: any, action: any) => {
      state.productList = action.payload;
    });
    builder.addCase(getProductList.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    builder.addCase(addProductList.fulfilled, (state: any, action: any) => {
      state.productList.unshift(action.payload);
    });
    builder.addCase(addProductList.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    builder.addCase(updateProductList.fulfilled, (state: any, action: any) => {
      state.productList = state.productList.map((productList: any) =>
        productList.id === action.payload.id
          ? { ...productList, ...action.payload }
          : productList
      );
    });
    builder.addCase(updateProductList.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    builder.addCase(deleteProductList.fulfilled, (state: any, action: any) => {
      state.productList = state.productList.filter(
        (productList: any) =>
          productList.id.toString() !== action.payload.toString()
      );
    });
    builder.addCase(deleteProductList.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });

    // Grid View
    builder.addCase(getProductGrid.fulfilled, (state: any, action: any) => {
      state.productGrid = action.payload;
    });
    builder.addCase(getProductGrid.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    builder.addCase(addProductGrid.fulfilled, (state: any, action: any) => {
      state.productGrid.unshift(action.payload);
    });
    builder.addCase(addProductGrid.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    builder.addCase(updateProductGrid.fulfilled, (state: any, action: any) => {
      state.productGrid = state.productGrid.map((productGrid: any) =>
        productGrid.id === action.payload.id
          ? { ...productGrid, ...action.payload }
          : productGrid
      );
    });
    builder.addCase(updateProductGrid.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    builder.addCase(deleteProductGrid.fulfilled, (state: any, action: any) => {
      state.productGrid = state.productGrid.filter(
        (productGrid: any) =>
          productGrid.id.toString() !== action.payload.toString()
      );
    });
    builder.addCase(deleteProductGrid.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });

    // Overview
    builder.addCase(getReview.fulfilled, (state: any, action: any) => {
      state.reviews = action.payload;
    });
    builder.addCase(getReview.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    builder.addCase(addReview.fulfilled, (state: any, action: any) => {
      state.reviews.unshift(action.payload);
    });
    builder.addCase(addReview.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    builder.addCase(updateReview.fulfilled, (state: any, action: any) => {
      state.reviews = state.reviews.map((reviews: any) =>
        reviews.id === action.payload.id
          ? { ...reviews, ...action.payload }
          : reviews
      );
    });
    builder.addCase(updateReview.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
    builder.addCase(deleteReview.fulfilled, (state: any, action: any) => {
      state.reviews = state.reviews.filter(
        (reviews: any) => reviews.id.toString() !== action.payload.toString()
      );
    });
    builder.addCase(deleteReview.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error || null;
    });
  },
});

export default DiamondSlice.reducer;
export const {
  setCurrentPage,
  setIsLoading,
  addShapeError,
  addShapeSuccess,
  deleteShapeError,
  deleteShapeSuccess,
  getShapesError,
  getShapesSuccess,
  updateShapeError,
  updateShapeSuccess,
  setDiamondPrices,
  handleError,
  getCenterDiamondPricesSuccess,
  getCenterDiamondPricesError
  // countDiamondPrice
} = DiamondSlice.actions;
